import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import StaticColumnTable from "../../../../Components/Common/StaticColumnTable";
import StaticColumnHeadingTable from "../../../../Components/Common/StaticColumnHeadingTable";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI405_1 = ({ hide, downloadMode = false }) => {
  const [disabled, setDisabled] = useState(false);
  const [table, setTable] = useState([]);
  const [table1, setTable1] = useState([]);
  const [table2, setTable2] = useState([]);
  const [table3, setTable3] = useState([]);
  const [table4, setTable4] = useState([]);
  const [table5, setTable5] = useState([]);
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    [
      {
        fieldName: "gender",
        title: "Gender",
        type: "array",
        letter: "i.",
        tables: table,
        setTables: setTable,
        defaultSegments: ["Male", "Female"],
        paramater: "gender",
        fields: [
          {
            fieldName: "gender",
            title: "Gender",
            type: "text",
            placeholder: "Enter Text",
            width: "30%",
          },
          {
            fieldName: "percentage",
            title: "%",
            type: "percentage",
            width: "30%",
            placeholder: "Enter Percentage",
          },
          {
            fieldName: "remark",
            title: "Remark",
            type: "text",
            width: "30%",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
    [
      {
        fieldName: "ageGroups",
        title: "Age Groups",
        tables: table1,
        setTables: setTable1,
        type: "array",
        defaultSegments: [
          "Age Under 30 years old",
          "Age 30-50 years old",
          "Age Over 50 years old",
        ],
        letter: "ii.",
        paramater: "ageGroup",
        fields: [
          {
            fieldName: "ageGroup",
            title: "Age Group",
            type: "text",
            placeholder: "Enter Text",
            width: "30%",
          },
          {
            fieldName: "percentage",
            title: "%",
            type: "percentage",
            width: "30%",
            placeholder: "Enter Percentage",
          },
          {
            fieldName: "remark",
            title: "Remark",
            type: "text",
            width: "30%",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
    [
      {
        fieldName: "other",
        title:
          "Other relevant diversity indicators, such as minority or vulnerable groups",
        type: "array",
        tables: table2,
        setTables: setTable2,
        defaultSegments: ["Minority", "Vulnerable Groups"],
        paramater: "ageGroup",
        letter: "iii.",
        fields: [
          {
            fieldName: "ageGroup",
            title: "Age Group",
            type: "text",
            placeholder: "Enter Text",
            width: "30%",
          },
          {
            fieldName: "percentage",
            title: "%",
            type: "percentage",
            width: "30%",
            placeholder: "Enter Percentage",
          },
          {
            fieldName: "remark",
            title: "Remark",
            type: "text",
            width: "30%",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
  ];

  const inputData1 = [
    [
      {
        fieldName: "gender",
        title: "Gender",
        type: "array",
        letter: "i.",
        tables: table3,
        setTables: setTable3,
        paramater: "employeeCategory",
        fields: [
          {
            fieldName: "employeeCategory",
            title: "Employee Category",
            type: "text",
            placeholder: "Enter Text",
            width: "30%",
          },
          {
            fieldName: "male",
            title: "Male %",
            type: "percentage",
            width: "30%",
            placeholder: "Enter Percentage",
          },
          {
            fieldName: "female",
            title: "Female %",
            type: "percentage",
            width: "30%",
            placeholder: "Enter Percentage",
          },
        ],
      },
    ],
    [
      {
        fieldName: "ageGroups",
        title: "Age Groups",
        tables: table4,
        setTables: setTable4,
        type: "array",
        columnHeading: "Percentage of employee in age groups",
        letter: "ii.",
        paramater: "employeeCategory",
        fields: [
          {
            fieldName: "employeeCategory",
            title: "Employee Category",
            type: "text",
            placeholder: "Enter Text",
            width: "25%",
          },
          {
            fieldName: "underThirtyYrs",
            title: "Under 30 yrs old",
            type: "percentage",
            width: "22%",
            placeholder: "Enter Percentage",
          },
          {
            fieldName: "thirtytoFiftyYears",
            title: "30 - 50 yrs old",
            type: "percentage",
            width: "22%",
            placeholder: "Enter Percentage",
          },
          {
            fieldName: "overFiftyYrs",
            title: "Over 50 yrs old",
            type: "percentage",
            width: "22%",
            placeholder: "Enter Percentage",
          },
        ],
      },
    ],
    [
      {
        fieldName: "other",
        title:
          "Other relevant diversity indicators, such as minority or vulnerable groups",
        tables: table5,
        setTables: setTable5,
        type: "array",
        letter: "iii.",
        paramater: "employeeCategory",
        fields: [
          {
            fieldName: "employeeCategory",
            title: "Employee Category",
            type: "text",
            placeholder: "Enter Text",
            width: "30%",
          },
          {
            fieldName: "minorityGroup",
            title: "Minority Group",
            type: "percentage",
            width: "30%",
            placeholder: "Enter Percentage",
          },
          {
            fieldName: "vulnarableGroup",
            title: "Vulnerable Group",
            type: "percentage",
            width: "30%",
            placeholder: "Enter Percentage",
          },
        ],
      },
    ],
  ];

  const defaultSegments = [
    "Permanent employees",
    "Temporary employees",
    "Permanent workers",
    "Temporary workers",
  ];

  const navigate = useNavigate();
  const { id } = useParams();

  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI400`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear : false)
        setDisabled(true);
      const res1 = res?.data?.data?.GRI400?.dicersityOfGoveranceBody;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // let v2 = validateTable(inputData, table, setTabErros);

      // if (!v2) return;

      let transformedData2 = {
        dicersityOfGoveranceBody: {
          governanceDiversityPercentage: {
            ...restructureData(table),
            ...restructureData(table1),
            ...restructureData(table2),
          },
          employeeDiversityPercentage: {
            ...restructureData(table3),
            ...restructureData(table4),
            ...restructureData(table5),
          },
        },
        type: "GRI400",
        submitted405_1: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri400/405-2/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/405-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && (
        <p
          className={styles.section_heading}
          style={{ marginBottom: hide ? "-1rem" : "0" }}
        >
          405 : Diversity and Equal Opportunity
        </p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        405-1 : Diversity of governance bodies and employees
      </p>
      <p
        className={styles.ques_heading}
        style={{
          textIndent: "-1rem",
          marginTop: hide ? "0.5rem" : "2rem",
          marginBottom: hide ? "-1rem" : "0",
        }}
      >
        a. What percentage of individuals serving within the organization’s
        governance bodies fall into each of the following diversity categories?
      </p>
      {/* a */}
      {inputData?.map((el) => (
        <StaticColumnTable
          {...{
            inputData: el,
            disabled: disabled,
            tables: el[0].tables,
            setTables: el[0].setTables,
            errors: tabErrors,
            setErrors: setTabErros,
            data: data?.governanceDiversityPercentage,
            defaultSegments: el[0]?.defaultSegments,
            parameter: el[0]?.paramater,
          }}
        />
      ))}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box
        sx={{ display: "flex", gap: 1, marginBottom: hide ? "-1.5rem" : "0" }}
      >
        <p className={styles.ques_heading}>b.</p>
        <p className={styles.ques_heading}>
          What percentage of employees within each employee category represent
          the following diversity categories?
        </p>
      </Box>
      {/* a */}
      {inputData1?.map((el) =>
        el[0].columnHeading ? (
          <StaticColumnHeadingTable
            {...{
              inputData: el,
              tables: el[0].tables,
              disabled: disabled,
              setTables: el[0].setTables,
              errors: tabErrors,
              setErrors: setTabErros,
              data: data?.employeeDiversityPercentage,
              defaultSegments: defaultSegments,
              parameter: el[0]?.paramater,
            }}
          />
        ) : (
          <StaticColumnTable
            {...{
              inputData: el,
              tables: el[0].tables,
              disabled: disabled,
              setTables: el[0].setTables,
              errors: tabErrors,
              setErrors: setTabErros,
              data: data?.employeeDiversityPercentage,
              defaultSegments: defaultSegments,
              parameter: el[0]?.paramater,
            }}
          />
        )
      )}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI405_1;
